import { get, post, remove } from "../common/http.services";

export function getSupplier(searchText: string, pageNumber: any, pageSize: any, appContext: any, success: any, error: any) {
    return get(`/supplier?searchText=${searchText}&page=${pageNumber}&size=${pageSize}&sort=name,asc`, appContext, success, error);
}

export function getAllSuppliers(appContext: any, success: any, error: any) {
    return get(`/supplier/getall`, appContext, success, error);
}

export function saveSupplier(supplierModel: any, appContext: any, success: any, error: any) {
    return post(`/supplier`, supplierModel, appContext, success, error);
}

export function deleteSupplier(id: any, appContext: any, success: any, error: any) {
    return remove(`/supplier?id=${id}`, appContext, success, error);
}

export function getSupplierById(id: any, appContext: any, success: any, error: any) {
    return get(`/supplier/findbyid?id=${id}`, appContext, success, error);
}

